import { Controller } from "@hotwired/stimulus"

// Monthly | Yearly on the change-plan page (SMA-81). Shows the amount and caption marked for
// the chosen interval and sets the interval every card's form (checkout or preview) sends.
// Everything the toggle changes is inside this controller's element.
export default class extends Controller {
  static targets = ["choice", "monthly", "yearly"]
  static values = { interval: { type: String, default: "monthly" } }

  connect() {
    this.apply(this.intervalValue)
  }

  select(event) {
    this.intervalValue = event.params?.interval ?? "monthly"
    this.apply(this.intervalValue)
  }

  apply(interval) {
    this.monthlyTargets.forEach((el) => { el.hidden = interval !== "monthly" })
    this.yearlyTargets.forEach((el) => { el.hidden = interval !== "yearly" })

    this.choiceTargets.forEach((button) => {
      const active = button.dataset.planIntervalIntervalParam === interval
      button.setAttribute("aria-pressed", String(active))
      button.classList.remove("text-white", "bg-primary-700", "dark:bg-primary-600", "text-gray-700", "dark:text-gray-200")
      if (active) {
        button.classList.add("text-white", "bg-primary-700", "dark:bg-primary-600")
      } else {
        button.classList.add("text-gray-700", "dark:text-gray-200")
      }
    })

    this.element.querySelectorAll('input[name="interval"]').forEach((input) => { input.value = interval })
  }
}
